import { VERSION_ID_PARAM } from '../../constants/query-params'
import { store } from '../../../index'

const addVersionIdToUrl = config => {
    const versionId = new URLSearchParams(window.location.search).get(VERSION_ID_PARAM)
    if (versionId) config.url += `${config.url.includes('?') ? '&' : '?'}${VERSION_ID_PARAM}=${versionId}`
}

const addLastModifiedToHeaders = config => {
    const clientAssignmentLastModified = store.getState().assignmentSlice?.clientAssignmentLastModified
    if (clientAssignmentLastModified) config.headers['last-modified'] = clientAssignmentLastModified
}

const configureRequestInterceptors = axiosInstance => {
    axiosInstance.interceptors.request.use(config => {
        addVersionIdToUrl(config)
        addLastModifiedToHeaders(config)
        return config
    })
}

export default configureRequestInterceptors
